import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography } from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
  heading: {
    fontSize: "13px",
    letterSpacing: "3px",
    fontWeight: "600",
    textAlign: "left",
    textTransform: "uppercase",
  },
  item: {
    display: "flex",
    flexDirection: "row",
    backgroundColor: "#fff",
    padding: "3px 15px",
    alignItems: "center",
    border: "1px solid #eee",
  },
  no: {
    color: "#777",
  },
}));

export default function TopList({ heading, items }) {
  const classes = useStyles();

  const _renderItem = (item, index) => {
    return (
      <div className={classes.item}>
        <p className={classes.no}>{index + 1}</p>
        <img
          src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRnkqgtD7ufXYfvujAudMVpQoRjE-Hl3aShbw&usqp=CAU"
          style={{ width: "20px", marginRight: "20px", marginLeft: "20px" }}
        />
        <p>Mobile phone</p>
      </div>
    );
  };
  return (
    <>
      <Typography variant="body1" color="primary" className={classes.heading}>
        {heading}
      </Typography>
      <div style={{ marginTop: "5px" }}>
        {[1, 2, 3, 4, 5].slice(0, 5).map((item, index) => _renderItem(item, index))}
      </div>
    </>
  );
}
